import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CostCenterState } from '../cost-centers/cost-center.store';
import { EasypayContractGroupState } from './easypay-contract-groups/easypay-contract-group.store';
import { InvoiceGroup } from './invoice-group.interface';
import { InvoiceGroupService } from './invoice-group.service';

const service = new InvoiceGroupService();

export interface InvoiceGroupState {
   //sub-modules
   costCenter?: CostCenterState;
   easypayContractGroup?: EasypayContractGroupState;
}

const InvoiceGroupStore: Module<InvoiceGroupState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getInvoiceGroups(_, payload: { companyId: number; query?: LocationQuery }) {
         return await service.getInvoiceGroups(payload.companyId, payload.query);
      },
      async createInvoiceGroup(_, payload: { companyId: number; invoiceGroup: InvoiceGroup }) {
         return await service.createInvoiceGroup(payload.companyId, payload.invoiceGroup);
      },
      async changeInvoiceGroup(_, payload: { companyId: number; invoiceGroupId: number; invoiceGroup: InvoiceGroup }) {
         return await service.putInvoiceGroup(payload.companyId, payload.invoiceGroupId, payload.invoiceGroup);
      },
      async deleteInvoiceGroup(_, payload: { companyId: number; invoiceGroupId: number }) {
         return await service.deleteInvoiceGroup(payload.companyId, payload.invoiceGroupId);
      },
      async archiveInvoiceGroup(_, payload: { companyId: number; invoiceGroupId: number }) {
         return await service.archiveInvoiceGroup(payload.companyId, payload.invoiceGroupId);
      },
      async restoreInvoiceGroup(_, payload: { companyId: number; invoiceGroupId: number }) {
         return await service.restoreInvoiceGroup(payload.companyId, payload.invoiceGroupId);
      },
      async deleteInvoiceGroupPermanently(_, payload: { companyId: number; invoiceGroupId: number }) {
         return await service.deleteInvoiceGroupPermanently(payload.companyId, payload.invoiceGroupId);
      },
   },
};

export default InvoiceGroupStore;
